module.exports = __webpack_public_path__ + "static/media/evRiesg_3.00cc7e82.png";